import React, { useContext, useEffect, useState } from 'react'
import { ContactContext, ContactContextPayload } from '../../../context/contactContext';
import { campaignContactFieldData, contact_data, countryCodesInterface, createCampaignContactPayload, getListOfCampaignContactFieldResponse, tagDataInterface } from '../../../models/axiosModel';
import style from './../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss';
import globalStyle from "../../../assets/styles/global.module.scss";
import { useSearchParams } from 'react-router-dom';
import { Autocomplete, Grid, TextField, Typography } from '@mui/material';
import Required from '../../utility/required';
import { flagAddTagDialogObj } from './contactsGlobal';
import GlobalButton from '../../utility/globalButton/button';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import RenderCustomOption from '../../global/autocomplete/renderCustomOption';
import { getCustomTagOption, getUpdatedFieldData, isGenericTag, isOptOutMetaTag, phoneNumberRegEx, isRequiredContactField } from './contactConstant';
import { parsePhoneNumber, CountryCode  } from 'libphonenumber-js/mobile';
import { hasContactManageAccess } from '../../../utils/constants';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface CreateSingleContactProps {
    getListOfCampaignContactFieldApiCall: (list_id: number) => void,
    setFlagAddTagDialogObj: React.Dispatch<React.SetStateAction<flagAddTagDialogObj>>,
    getCampaignContactApiCall: (list_id: number) => void,
    getCountryCodeApiCall: () => Promise<void>,
    onClickOfCustomTagOption: (flagEditTagPopup: boolean, flagEditTag: boolean, tag?: tagDataInterface) => void,
    onClickOfDeleteTag: (tag: tagDataInterface) => void,
}

const CreateSingleContact: React.FC<CreateSingleContactProps> = (props) => {

    const { getListOfCampaignContactFieldApiCall, setFlagAddTagDialogObj, getCampaignContactApiCall, getCountryCodeApiCall, onClickOfCustomTagOption, onClickOfDeleteTag } = props;
    const { campaignContactFieldData, campaignContactTagData, setFlagCreateNewContactDialog, createCampaignContactApi, countryCodeList } = useContext(ContactContext) as ContactContextPayload;
    const { setFlagLoading, userDetail, handleError, apiRoutesPermissionAssignment } = useContext(UserContext) as UserContextPayload;

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [searchParams, setSearchParams] = useSearchParams();
    const list_id = searchParams.get('contact_list_id');

    const [flagInValidPhoneNumber, setFlagInValidPhoneNumber] = useState<boolean>(false);

    const innerHeight = window.innerHeight - 265;

    const setDefaultPayload = (): createCampaignContactPayload => {
        return {
            contact_list_id: Number(list_id),
            contact_tag_id: [],
            contact_data: campaignContactFieldData?.contact_field_data?.map((field: campaignContactFieldData) => {
                return {
                    contact_field_id: field.contact_field_id,
                    contact_data_value: "",
                }
            }) || [],
        }
    }

    const [createContactPayload, setCreateContactPayload] = useState<createCampaignContactPayload>(setDefaultPayload());

    useEffect(() => {
        if (campaignContactFieldData) {
            getListOfCampaignContactFieldApiCall(Number(list_id));
        }
        if(!countryCodeList){
            getCountryCodeApiCall(); // Get Country Code (Generic Call).
        }
    }, []);

    useEffect(() => {
        if (campaignContactFieldData) {
            setCreateContactPayload(setDefaultPayload());
        }
    }, [campaignContactFieldData]);

    const createCampaignContactApiCall = async (payload: createCampaignContactPayload) => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
        const res = await createCampaignContactApi(payload);
        if (!(res.status)) {
            handleError(res);
        } else {
            showSuccess(`Contact Created Successfully`)
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
    }

    const handleValidatePhoneNumber = (phoneNumber: string, countryCode: string) => {
        try {
            const validate = parsePhoneNumber(phoneNumber, countryCode as CountryCode);
            if(!validate.isValid() || validate.country != countryCode || !(validate.getType()?.toLowerCase() == "undefined" ||  validate.getType()?.toLowerCase().indexOf('mobile') != -1 )){
                setFlagInValidPhoneNumber(true);
            } else {
                setFlagInValidPhoneNumber(false);
            }
        } catch (err) {
            setFlagInValidPhoneNumber(true);
        }
    }

    // const onBlurOfPhoneNumber = useCallback(
    //     debounce((phoneNumber: string, countryCode: string) => {
    //         handleValidatePhoneNumber(phoneNumber, countryCode);
    //     }, 1200), []
    // );

    const getAnyValueFromPayload = (contact_field_id: number | undefined) => {
        if(contact_field_id){
            return createContactPayload.contact_data.find((data) => data.contact_field_id == contact_field_id)?.contact_data_value || "";
        }
        return "";
    }

    const getPhoneNumberField = (campaignContactFieldData: getListOfCampaignContactFieldResponse | null) => {
        return campaignContactFieldData?.contact_field_data?.find((field) => field.contact_field_name.toLowerCase() == "phone number");
    }

    const getContryCodeField = (campaignContactFieldData: getListOfCampaignContactFieldResponse | null) => {
        return campaignContactFieldData?.contact_field_data?.find((field) => ["country_code", "country code"].includes(field.contact_field_name.toLowerCase()));
    }

    const onChangeOfContactField = (value: string, field_id: number, field_name: string) => {
        setCreateContactPayload((prev: createCampaignContactPayload) => ({
            ...prev,
            contact_data: prev.contact_data?.map((contact: contact_data) => {
                if (contact.contact_field_id == field_id) {
                    contact.contact_data_value = value;
                }
                return contact;
            })
        }));

        if(["phone number", "country_code", "country code"].includes(field_name.toLowerCase())){
            const countryCodeField = getContryCodeField(campaignContactFieldData);
            const countryCodeValue = getAnyValueFromPayload(countryCodeField?.contact_field_id);
            
            const phoneNumberField =  getPhoneNumberField(campaignContactFieldData);
            const phoneNumberValue = getAnyValueFromPayload(phoneNumberField?.contact_field_id);

            if(countryCodeField && countryCodeValue && phoneNumberField && phoneNumberValue){
                // onBlurOfPhoneNumber(phoneNumberValue, countryCodeValue); 
                handleValidatePhoneNumber(phoneNumberValue, countryCodeValue);
            } else {
                setFlagInValidPhoneNumber(false);
            }
        }
    }

    const onChangeOfTag = (value: tagDataInterface[]) => {
        let flag_new_tag = false;
        for (let i = 0; i < value.length; ++i) {
            if (value[i].contact_tag_id === -1 && value[i].contact_tag_name === "New Tag") {
                flag_new_tag = true;
                break;
            }
        }
        if (flag_new_tag) {
            setFlagAddTagDialogObj((prev: flagAddTagDialogObj) => ({
                flag: true,
                flagFromEditContactDialog: false,
            }))
        } else {
            setCreateContactPayload((prev: createCampaignContactPayload) => ({
                ...prev,
                contact_tag_id: value.map((tags: tagDataInterface) => {
                    return tags.contact_tag_id;
                }),
            }))
        }
    }

    const checkDisableSaveButton = () => {
        if (createContactPayload?.contact_data.length == 0) {
            return true;
        }

        
        for (let i = 0; i < createContactPayload?.contact_data.length; ++i) {
            const currentContact = createContactPayload?.contact_data[i];
            const currentField = campaignContactFieldData?.contact_field_data?.find((field: campaignContactFieldData) => field.contact_field_id == currentContact.contact_field_id);
            
            const isRequired = currentField ? isRequiredContactField(currentField?.contact_field_name) : false;
            if (isRequired && currentContact.contact_data_value.trim() == "") {
                return true;
            }
        }

        // Validate Contact Number
        const phoneNumberField = getPhoneNumberField(campaignContactFieldData);
        const countryCodeField =  getContryCodeField(campaignContactFieldData);

        if(phoneNumberField && countryCodeField){
            const phoneNumber = getAnyValueFromPayload(phoneNumberField.contact_field_id);
            const countryCode = getAnyValueFromPayload(countryCodeField.contact_field_id);

            if(countryCode.length > 0 && phoneNumber.length > 0){
                try {
                    const validate = parsePhoneNumber(phoneNumber, countryCode as CountryCode);
                    if(validate.isValid() && validate.country == countryCode && (validate.getType()?.toLowerCase() == "undefined" ||  validate.getType()?.toLowerCase().indexOf('mobile') != -1 )){
                        if(flagInValidPhoneNumber) setFlagInValidPhoneNumber(false);
                        return false;
                    } else return true;
                } catch (err) {
                    return true;
                }
            }
        }
        return false;
    }

    const handleCancelClick = () => {
        setCreateContactPayload(setDefaultPayload());
        setFlagCreateNewContactDialog(false);
    }

    const getUpdatedPayload = () => {
        let phoneNumber = "", countryCode=  "";

        const phoneNumberField = campaignContactFieldData?.contact_field_data?.find((field: campaignContactFieldData) => field.contact_field_name.toLowerCase() == "phone number");
        const countryCodeField =  campaignContactFieldData?.contact_field_data?.find((field: campaignContactFieldData) => (field.contact_field_name.toLowerCase() == "country_code" || field.contact_field_name.toLowerCase() == "country code"));
        if(phoneNumberField && countryCodeField){
            phoneNumber = getAnyValueFromPayload(phoneNumberField.contact_field_id);
            countryCode = getAnyValueFromPayload(countryCodeField.contact_field_id);
        }

        try {
            const validate = parsePhoneNumber(phoneNumber, countryCode as CountryCode);
            if(validate.isValid()){
                return {
                    ...createContactPayload, 
                    contact_data: createContactPayload.contact_data.map((data) => {
                        const currentField = campaignContactFieldData?.contact_field_data?.find((field: campaignContactFieldData) => field.contact_field_id == data.contact_field_id);
                        if(currentField?.contact_field_name.toLowerCase() == "phone number"){
                            return {
                                ...data, 
                                contact_data_value: validate.formatInternational().replace(/\D/g, ''),
                            }
                        }
                        return data;
                    })
                }
            }
            return createContactPayload;
        } catch(err) {
            return createContactPayload;
        }
    }

    const handleCreateClick = async () => {
        const payload =  getUpdatedPayload();
        await createCampaignContactApiCall(payload);
        setFlagCreateNewContactDialog(false);
        getCampaignContactApiCall(Number(list_id));
    }

    const renderTagOption = (props: React.HTMLAttributes<HTMLLIElement>, option: tagDataInterface): React.ReactNode => {
        const isCustomOption = option.contact_tag_id === -1;

        const optionForRender = { ...option, contact_tag_id: isCustomOption ? -1 : option.contact_tag_id };

        return (
            <RenderCustomOption 
                autocompleteRenderOptionProps={props} 
                option={option} 
                customOptionName={"New Tag"} 
                optionName={option['contact_tag_name']} 
                optionLabelKey={'contact_tag_id'} 
                onClickOfCustomOption={() => onClickOfCustomTagOption(false, false)} 
                flagShowEditOptionIcon={hasContactManageAccess(apiRoutesPermissionAssignment, userDetail) && !isGenericTag(option?.contact_list_id)}
                onClickOfEditOption={(e: React.MouseEvent<HTMLDivElement, MouseEvent>, option: tagDataInterface) => {e.stopPropagation(); onClickOfCustomTagOption(false, true, option)}}
                flagShowDeleteOptionIcon={hasContactManageAccess(apiRoutesPermissionAssignment, userDetail) && !isGenericTag(option?.contact_list_id)}
                onClickOfDeleteOption={(e: React.MouseEvent<HTMLDivElement, MouseEvent>, option: tagDataInterface) => { e.stopPropagation(); onClickOfDeleteTag(option) }}
            />
        );
    };

    return (
        <>
            <Grid container className={style.singleContactDialogContainer}>
                <Grid item xs={12} className={style.singleContactScrollableSection} style={{ maxHeight: `${innerHeight}px` }}>
                    <Grid container spacing={2}>
                        {getUpdatedFieldData(campaignContactFieldData?.contact_field_data)?.map((field: campaignContactFieldData, ind: number) => {
                            return (
                                <Grid key={ind} item lg={6} xs={12}>
                                    <Grid container className={style.createContactFieldContainer}>
                                        <Grid xs={12}>
                                            <Grid container gap="5px" alignItems={"center"}>
                                                <Typography className={style.popupFieldTypography}>{field.contact_field_name} {isRequiredContactField(field?.contact_field_name) && <Required />}</Typography>
                                            </Grid>

                                        </Grid>
                                        <Grid xs={12}>
                                            {(field.contact_field_name.toLowerCase() == "country_code" || field.contact_field_name.toLowerCase() == "country code") ? 
                                                <>
                                                    <Autocomplete
                                                        className={`${style.contactFilterDropdownsInPopup}`}
                                                        options={countryCodeList || []}
                                                        getOptionLabel={(option) => `${option.country_name} (+${option.country_code})`}
                                                        value={countryCodeList?.find((code) => code.country_iso_code == createContactPayload?.contact_data?.find((contact: contact_data) => contact.contact_field_id == field.contact_field_id)?.contact_data_value) || null}
                                                        onChange={(_: React.SyntheticEvent, value: countryCodesInterface | null) => onChangeOfContactField(value ? value.country_iso_code : "", field.contact_field_id, field.contact_field_name)}
                                                        renderInput={(params) => <TextField {...params} placeholder='Select Country Code' />}
                                                    />
                                                </>
                                                :
                                                <>
                                                    <TextField
                                                        value={createContactPayload?.contact_data?.find((contact: contact_data) => contact.contact_field_id == field.contact_field_id)?.contact_data_value || ""}
                                                        onChange={(e) => {
                                                            if(field.contact_field_name.toLowerCase() == "phone number"){
                                                                // Remove spaces before validating and saving
                                                                const phoneNumberValue = e.target.value.replace(/\s/g, "");
                                                                if(phoneNumberRegEx.test(phoneNumberValue)){
                                                                    onChangeOfContactField(phoneNumberValue, field.contact_field_id, field.contact_field_name)
                                                                }
                                                            } else {
                                                                onChangeOfContactField(e.target.value, field.contact_field_id, field.contact_field_name)
                                                            }
                                                        }}
                                                        className={`${style.campaignContactPopupTextField} ${globalStyle.fullwidth}`}
                                                        placeholder={`Enter ${field.contact_field_name}`}
                                                    />
                                                    {(flagInValidPhoneNumber && field.contact_field_name.toLowerCase() == "phone number") && <span className={style.inValidPhoneNumberSpan}>Please Enter Valid Phone Number</span>}
                                                </>
                                            }

                                        </Grid>
                                    </Grid>
                                </Grid>
                            );
                        })}

                        <Grid item xs={12}>
                            <Grid container className={style.createContactFieldContainer}>
                                <Grid item xs={12}>
                                    <Typography className={style.popupFieldTypography}>Tag</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Autocomplete
                                        className={`${style.contactFilterDropdownsInPopup}`}
                                        options={(campaignContactTagData[0].contact_tag_data) ? [...(campaignContactTagData[0].contact_tag_data), ...(getCustomTagOption(apiRoutesPermissionAssignment, userDetail))] : []}
                                        getOptionLabel={(option) => option.contact_tag_name || ''}
                                        multiple
                                        value={campaignContactTagData[0].contact_tag_data && campaignContactTagData[0].contact_tag_data?.length > 0
                                            ? campaignContactTagData[0].contact_tag_data.filter((tag) =>
                                                createContactPayload?.contact_tag_id.some((tag_id: number) => tag.contact_tag_id === tag_id)
                                            ) : []
                                        }
                                        onChange={(_: React.SyntheticEvent, value: tagDataInterface[]) => { onChangeOfTag(value); }}
                                        ListboxProps={{ className: style.singleContactListbox }}
                                        renderOption={renderTagOption}
                                        getOptionDisabled={(option) => isOptOutMetaTag(option?.contact_tag_name)}
                                        renderInput={params => {
                                            const { InputProps, ...restParams } = params;
                                            const { startAdornment, ...restInputProps } = InputProps;
                                            return (
                                                <TextField
                                                    {...restParams}
                                                    placeholder='Select Tags'
                                                    InputProps={{
                                                        ...restInputProps,
                                                        startAdornment: (
                                                            <div className={style.selectTagTextField}>
                                                                {startAdornment}
                                                            </div>
                                                        ),
                                                    }}
                                                />
                                            );
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Grid container className={style.contactPopupButtons}>
                        <Grid item>
                            <GlobalButton
                                buttonText="Cancel"
                                className="borderedButtonStyle"
                                sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                onClick={() => handleCancelClick()}
                            />
                        </Grid>
                        <Grid item>
                            <GlobalButton
                                buttonText="Create"
                                className='primaryButtonStyle'
                                sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                disabled={checkDisableSaveButton()}
                                onClick={() => handleCreateClick()}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default CreateSingleContact
